import Entities from 'STORE';

export async function inViewMessage(groupId: string, messageId: string): Promise<void> {
  Entities.viewportMessages.addViewportMessage({ groupId, messageId });
}
